<template>
	<div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
		<div role="group" class="form-group mb-2">
			<label class="d-block font-weight-bold">
				{{ label }}
				<span v-if="required" class="text-danger">*</span>
			</label>
			<div>
				<input
					v-model="item"
					v-on:input="$emit('input', item)"
					type="password"
					class="form-control"
					:placeholder="placeholder"
				/>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["value", "label", "required", "grid", "placeholder"],
	data() {
		return { item: null };
	},
	beforeMount() {
		this.item = this.value;
	},
	watch: {
		value(n, o) {
			this.item = n;
		},
	},
};
</script>
